import { createContext } from 'react'

export type OpenReplayContextType = {
  setUserID: (id: string) => void
  setMetadata: (key: string, value: string) => void
  getSessionID: () => string | null | undefined
}

export const OpenReplayContext = createContext<OpenReplayContextType>({} as OpenReplayContextType)

OpenReplayContext.displayName = 'OpenReplayContext'
